module.exports = __webpack_public_path__ + "images/illustrations/illustration-rise-birds-2-418b38bfa1980c0bcf37d67ea1a32753.webp";